export const isDescriptionExists = (descriptionArray) =>
	Boolean(
		descriptionArray &&
			descriptionArray[0] &&
			(descriptionArray[0].length ||
				typeof descriptionArray[0] === "object")
	);
